<template>
  <div class="swiper-box">
    <ul class="tab swiper-container-informationTab">
      <div class="swiper-button-prev"></div>
      <div class="swiper-wrapper">
        <li
          v-for="(item, index) in tabList"
          :key="item.dictValue"
          :class="[item.dictValue === tabId ? 'tabActive' : '', 'swiper-slide']"
          @click="tabClick(item, index)"
        >
          {{ item.dictLabel }}
        </li>
      </div>
      <div class="swiper-button-next"></div>
    </ul>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  props: {
    tabList: {
      type: Array,
      default: () => [],
    },
    tabId: {
      type: String,
      default: null,
    },
  },
  data() {
    return {};
  },
  watch: {},
  created() {},
  mounted() {
    this.initSwiper();
  },
  methods: {
    //swiper轮播图
    initSwiper() {
      this.mySwiper = new Swiper(".swiper-container-informationTab", {
        slidesPerView: 7, // 设置一次显示三个
        slidesPerGroup: 1, // 每次滑动一个组（这里一个组就是一个元素）
        // 分页
        pagination: {
          el: ".swiper-pagination-informationTab",
          clickable: true,
        },
        //前进后退按钮
        // navigation: {
        //     nextEl: '.swiper-button-next',
        //     prevEl: '.swiper-button-prev',
        // },
      });
    },

    tabClick(item, index) {
      this.$emit("tabClick", item, index);
    },
  },
};
</script>
<style lang="scss" scoped>
.swiper-box {
  .tab {
    width: 100%;
    overflow: hidden;
    display: flex;
    align-items: center;

    .swiper-button-prev,
    .swiper-button-next {
      z-index: 10;
      width: 40px;
      height: 40px;
      margin: 0;
      display: none;
    }

    .swiper-button-prev {
      top: -3%;
      left: -25px;
      width: 50px;
    }

    .swiper-wrapper {
      width: 100%;
      overflow: hidden;

      & > li {
        width: 120px;
        text-align: center;
        margin-right: 10px;
        background-color: #e5e5e5;
        background-color: #e2e2e2;
        line-height: 40px;
        font-size: 14px;
        cursor: pointer;
        transition: all 0.3s;
      }

      .tabActive {
        background-color: $menu-active-color;
        color: $bg-color1;
      }
    }
  }
}
</style>
